const excludeNames = [
  'nid',
  'id',
  'title',
  'uid',
  'created',
  'changed',
  'language',
  'annualMode',
  'q',
  'q1',
  'q2',
  'q3',
  'q4',
  'initiatives',
  'customResources',
  'kpi',
  'guestPlan',
  'teamPlan',
  'higherTicketsPlan',
  'plannedGuestCount',
  'actualGuestCount',
  'actualArtistCount',
  'plannedArtistCount',
  'plannedSpCount',
  'retailTransactions',
  'serviceTransactions',
  'plannedHigherTicketsCount',
  'plannedRetailTicketsCount',
  'm1',
  'm2',
  'm3',
  'm4',
  'recipientEmail',
  'selectedActionPlan',
];
export const convertToCapCase = (fieldName: string): string => {
  return fieldName
    .replace('field_', '')
    .split('_')
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
};

const isUppercaseIncluded = (value: string): boolean => /[A-Z]/.test(value);

export const convertToSnakeCase = (fieldName: string): string => {
  if (excludeNames.includes(fieldName))
    return isUppercaseIncluded(fieldName)
      ? fieldName.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
      : fieldName;
  return `field_${fieldName.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()}`;
};

const isObject = (value: any): boolean => {
  return value?.constructor === Object;
};

const isArray = (value: any): boolean => {
  return value?.constructor === Array;
};

export const RESTDataArrayMapper = (input: any, isIncome?: boolean) => {
  return input.map((item: any) =>
    isObject(item)
      ? RESTDataMapper(item, isIncome)
      : isIncome
        ? convertToCapCase(item)
        : convertToSnakeCase(item),
  );
};

export const filterAndRenameObjectKeys = <T extends object, K extends keyof T, NK extends string>(
  obj: T,
  keysMap: Record<K, NK>,
): { [P in NK]: T[K] } => {
  const result: Partial<{ [P in NK]: T[K] }> = {};

  (Object.keys(keysMap) as K[]).forEach((oldKey) => {
    const newKey = keysMap[oldKey] as NK;
    if (obj && Object.prototype.hasOwnProperty.call(obj, oldKey)) {
      result[newKey] = obj[oldKey];
    }
  });

  return result as { [P in NK]: T[K] };
};

export const RESTDataMapper = (
  input: Record<string, any>,
  isIncome?: boolean,
  isInput?: boolean,
) => {
  const output: Record<string, any> = {};

  for (const key in input) {
    const newKey = isIncome || key === 'kpi' ? convertToCapCase(key) : convertToSnakeCase(key);
    if (key === 'kpi' && isInput) {
      output[newKey] = input[key];
    } else if (isObject(input[key])) {
      output[newKey] = RESTDataMapper(input[key], isIncome);
    } else if (isArray(input[key])) {
      output[newKey] =
        key !== 'recipientEmail' ? RESTDataArrayMapper(input[key], isIncome) : input[key];
    } else {
      output[newKey] = input[key];
    }
  }

  return output;
};
